import { FooterTemplate } from "app/Footer";
import { HeaderTemplate } from "app/Header";
import Loading from "common/ui/Loading";
import React from "react";


const LazyLoadingPlaceholder: React.FC = () => {
    return <>
        <HeaderTemplate
            name={""}
            isCustomer={false}
            activeMerchant={null}
            merchants={[]}
            dashboardPath={"/"}
            nonProdHeader={false}
            showTranslations={false}
            isLoggedIn={true}
            showBidEditor={false}
            showReports={false}
            showPositions={false}
            onLogout={() => {}}
            showNotificationCenter={false}
         />
        <Loading />
        <FooterTemplate activeMerchant={null} isCustomer={false} />
    </>;
}

export default LazyLoadingPlaceholder